module.exports = __webpack_public_path__ + "img/product_102.741c69f.webp";